import { getCountries, getCountryCallingCode } from "libphonenumber-js";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { Input } from "./ui/input";

const PRIORITY_COUNTRIES = ["IN", "US", "GB", "CA", "AU", "AE", "MX", "SG"];
const ALL_COUNTRIES = getCountries();
const ORDERED_COUNTRIES = [...PRIORITY_COUNTRIES, ...ALL_COUNTRIES.filter((c) => !PRIORITY_COUNTRIES.includes(c))];

export function PhoneInput({ country, national, onCountryChange, onNationalChange, testId, className, inputClassName, triggerClassName }) {
  return (
    <div className={`flex gap-2 ${className || ""}`}>
      <Select value={country} onValueChange={onCountryChange}>
        <SelectTrigger data-testid={`${testId}-country`} className={`w-24 shrink-0 rounded-sm bg-white border-slate-300 ${triggerClassName || ""}`}>
          <SelectValue>+{getCountryCallingCode(country)}</SelectValue>
        </SelectTrigger>
        <SelectContent className="max-h-64">
          {ORDERED_COUNTRIES.map((c) => (
            <SelectItem key={c} value={c}>
              {c} +{getCountryCallingCode(c)}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Input
        data-testid={testId}
        type="tel"
        inputMode="numeric"
        placeholder="Phone number"
        value={national}
        onChange={(e) => onNationalChange(e.target.value.replace(/\D/g, "").slice(0, 15))}
        className={`rounded-sm bg-white border-slate-300 flex-1 ${inputClassName || ""}`}
      />
    </div>
  );
}
